import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TextField from '../TextField'
import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import Tooltip from './tooltip'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const MissionBlockEditModal = ({
  closeModal,
  attribute,
  translate,
}) => {


  useEffect(() =>  {

    const pictogramDiv = document.querySelector(".pictograms-area")
    if(pictogramDiv) setHasScroll(pictogramDiv.clientHeight < pictogramDiv.scrollHeight)
  }, [])

  const [hasScroll,setHasScroll] = useState(false)

  // eslint-disable-next-line react/prop-types
  const renderPictogramsImages = () =>   attribute.pictograms.map((pictogram,index) => 
  
    <div key={index}>
      
      <Tooltip direction="top" delay={1} content={pictogram.name}>
        <p  
        id={pictogram.name} 
        style={{marginLeft: '0px', maxWidth: '120px', whiteSpace:"nowrap", overflow: "hidden", textOverflow: "ellipsis"}} 
        className='pictogram-view-name'>{pictogram.name}
        </p>
        
      </Tooltip>
      <div className='pictogram-box'>
         {pictogram.url && <img style={{display: 'flex', width: '111px', height: '112px'}} src={pictogram.url} />}
      </div>
    
    </div>  
       )
  
  return (
    <>
    
      <Modal
        closeModal={closeModal}
        size='md'
        className={`pictograms-add-modal`}
      >
        <h3 style={{fontSize: '24px', marginBottom:'32px', marginTop: '-1px', paddingTop: '4px'}}>
          <strong style={{color: 'black'}}>Visualizar cadastro de atributo</strong>
        </h3>

        <p style={{marginBottom:'-10px', color: '#222020', fontWeight: '600', fontSize: '13px'}}>Atributo</p>
        <TextField
                  type='text'
                  required
                  disabled
                  
                  value={attribute.name}
                  placeholder="Digite um nome de atributo"
                  fill
                  
                  validateValue={() => false}
                
                />
        
        <p style={{marginBottom:'16px', color: '#222020', fontWeight: '600', fontSize: '13px'}}>Pictogramas</p>
        <section  className={`pictograms-area ${hasScroll ? 'pictogram-border' : ''}`} >
          
          {renderPictogramsImages()}
      
        </section>
        <div className='mission-block-new-modal-actions'>

          <button
            
            disabled
            onClick={() =>  {
            closeModal()
            }}
            className='mission-save'
          >
            {translate('save_button_label')}
          </button>

          <button
            onClick={() => { closeModal() }}
            className='mission-cancel'
          >
          {translate('close_button_label')}
          </button>


        </div>
      </Modal>
    </>
    
  )
}

MissionBlockEditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  attribute: PropTypes.object.isRequired
}


export default Form({ fields: FIELDS })(MissionBlockEditModal)

export { MissionBlockEditModal }
